(function (app, ng) {

    app.provider("customFieldApi", [
        function () {
            this.$get = ["crmApiGateway", function (crmApiGateway) {
                var service = {};

                // GETs
                service.getAllCustomFields = function () {
                    return crmApiGateway.get("/CustomFields/All");
                };

                service.getClientCustomFields = function () {
                    return crmApiGateway.get("/CustomFields/Client");
                };

                service.getAccountCustomFields = function () {
                    return crmApiGateway.get("/CustomFields/Account");
                };

                //POSTs
                service.add = function (customField) {
                    return crmApiGateway.post("/CustomFields", customField);
                };

                service.update = function (customField) {
                    return crmApiGateway.post("/CustomFields", customField);
                };

                service.remove = function (customField) {
                    var field = customField;
                    field.IsActive = false;
                    return crmApiGateway.post("/CustomFields", field);
                };

                service.updateClientEntry = function (entry) {
                    return crmApiGateway.post("/CustomFields/Entry/Client", entry);
                };

                service.updateAccountEntry = function (entry) {
                    return crmApiGateway.post("/CustomFields/Entry/Account", entry);
                };

                return service;
            }];
        }
    ]);

})(window.app, window.angular); // jshint ignore:line